import { CALL_API, REQUEST_GET } from '../middleware/api'
import { ARCHIVED_STUDY_COLLECTION } from '../schemas'
export const FETCH_ARCHIVED_STUDIES_REQUEST =
  'tru/archivedStudies/FETCH_ARCHIVED_STUDIES_REQUEST'
export const FETCH_ARCHIVED_STUDIES_SUCCEEDED =
  'tru/archivedStudies/FETCH_ARCHIVED_STUDIES_SUCCEEDED'
export const FETCH_ARCHIVED_STUDIES_FAILED =
  'tru/archivedStudies/FETCH_ARCHIVED_STUDIES_FAILED'

export const fetchArchivedStudies = ({
  page = 1,
  perPage = 30,
  sort = 'date',
  order = 'desc',
  query
}) => ({
  [FETCH_ARCHIVED_STUDIES_REQUEST]: { page, query },
  [CALL_API]: {
    types: [
      FETCH_ARCHIVED_STUDIES_REQUEST,
      FETCH_ARCHIVED_STUDIES_SUCCEEDED,
      FETCH_ARCHIVED_STUDIES_FAILED
    ],
    endpoint: 'archived_studies.json',
    requestType: REQUEST_GET,
    data: { page, perPage, order, sort, query },
    dataGetter: data => data.archivedStudies,
    schema: ARCHIVED_STUDY_COLLECTION
  }
})



// WEBPACK FOOTER //
// ../src/actions/archivedStudyActions.js